import * as React from 'react'
import { useState, useEffect, useRef } from 'react'
import {
  Grid,
  Divider,
  Typography,
  useMediaQuery,
  useTheme,
  Container,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Radio,
  Button,
  Checkbox,
  RadioGroup,
  IconButton,
} from '@mui/material'

import { showSnackbar } from '@context/SnackbarContext'
import { useParams, useLocation, useNavigate } from 'react-router-dom'
import moment from 'moment'
import { GlobalStyle as gs } from '@src/GlobalStyle'
import { useSelector, useDispatch } from 'react-redux'
import AddrPopup from '@components/AddrPopup'
import RecvPopup from '@components/RecvPopup'
import WebService from '@util/webService'
import { comma } from '@src/util/helper'
import useAlert from '@hooks/useAlert'
import FlatButton from '@components/FlatButton'
import * as ExcelJS from 'exceljs'
import axios from 'axios'
import FileDownloadOutlined from '@mui/icons-material/FileDownloadOutlined'
import MyDialog2 from '@components/MyDialog2'
import { isAdmin } from '@util/helper'

const boldFont = {
  fontWeight: 'bold',
}

const ContractDownloader = ({ order}) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const account = useSelector((state) => state.accountReducer)
  const codes = useSelector((state) => state.codeReducer)
  const [records, set_records] = useState([])
  const navigate = useNavigate()

  const { alert, renderAlert } = useAlert()

  const downloadTmpl = async () => {
    const url = `/order/download/tmpl`
    const response = await axios.get(url, { responseType: 'arraybuffer' })
    const buffer = response.data
    return buffer
  }

  const getPngSize = (base64) => {
    const binary = atob(base64.split(',')[1]);
    const data = new Uint8Array([...binary].map(c => c.charCodeAt(0)));
    const width = (data[16] << 24) | (data[17] << 16) | (data[18] << 8) | data[19];
    const height = (data[20] << 24) | (data[21] << 16) | (data[22] << 8) | data[23];
    return [ width, height ];
  }

  const getTargetWidth = (originalWidth, originalHeight, targetHeight) => {
    const ratio = originalWidth / originalHeight
    const targetWidth = Math.floor(targetHeight * ratio)
    return targetWidth
  }

  const columnToIndex = (col) => {
    let index = 0;
    for (let i = 0; i < col.length; i++) {
      index = index * 26 + (col.charCodeAt(i) - 64);
    }
    return index - 1; // A=0
  }

  // ExcelJS 의 소수점 col/row 앵커는 오프셋 환산이 실제와 달라 위치가 틀어지므로 EMU 오프셋을 직접 계산
  const EMU_PER_PX = 9525
  // 열 너비(문자 수) -> 픽셀: Excel 환산식 (Calibri 11, 최대 숫자 폭 7px)
  const colPx = (ws, colIdx) => {
    const w = ws.getColumn(colIdx + 1).width ?? 9
    return Math.trunc(((256 * w + Math.trunc(128 / 7)) / 256) * 7)
  }
  // 행 높이(pt) -> 픽셀, 숨김 행은 0
  const rowPx = (ws, rowIdx) => {
    const row = ws.getRow(rowIdx + 1)
    return row.hidden ? 0 : Math.round(((row.height ?? 15) * 96) / 72)
  }
  // w x h 이미지의 가운데가 (colIdx 열 왼쪽에서 centerX px, rowIdx 부터 rowCount 행 영역의 세로 가운데)에 오도록 하는 tl 앵커
  // centerX 가 작아 이미지가 왼쪽 열로 넘치면 앞 열로 옮겨 계산 (모두 0-based)
  const anchorAt = (ws, colIdx, centerX, rowIdx, rowCount, w, h) => {
    let c = colIdx
    let offX = centerX - w / 2
    while (offX < 0 && c > 0) {
      c -= 1
      offX += colPx(ws, c)
    }
    while (offX > 0 && offX >= colPx(ws, c)) {
      offX -= colPx(ws, c)
      c += 1
    }

    let boxH = 0
    for (let i = 0; i < rowCount; i++) {
      boxH += rowPx(ws, rowIdx + i)
    }
    let r = rowIdx
    let offY = (boxH - h) / 2
    // 이미지가 영역보다 크면 위쪽 행으로 올라감
    while (offY < 0 && r > 0) {
      r -= 1
      offY += rowPx(ws, r)
    }
    while (offY > 0 && offY >= rowPx(ws, r)) {
      offY -= rowPx(ws, r)
      r += 1
    }
    return {
      nativeCol: c,
      nativeColOff: Math.round(Math.max(0, offX) * EMU_PER_PX),
      nativeRow: r,
      nativeRowOff: Math.round(Math.max(0, offY) * EMU_PER_PX),
    }
  }
  // 한 열(colIdx)의 rowIdx 부터 rowCount 행 영역 정가운데
  const centerAnchor = (ws, colIdx, rowIdx, rowCount, w, h) => anchorAt(ws, colIdx, colPx(ws, colIdx) / 2, rowIdx, rowCount, w, h)


  const onDownload = async () => {
    const buffer = await downloadTmpl()
    const workbook = new ExcelJS.Workbook()
    await workbook.xlsx.load(new Uint8Array(buffer))

    const url = `/order/data/map/${order.id}`
    const resp = await WebService.get(url)
    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }

    const repMessage = JSON.parse(resp.repMessage)
    const dataMap = JSON.parse(repMessage.dataMap)
    console.log('dataMap=>', dataMap)
    const signature = repMessage.signature
    // const sigImage = dataUrlToFile(signature, 'signature')
    const [width, height] = getPngSize(signature)
    const imageId1 = workbook.addImage({
      base64: signature,
      extension: 'png',
    })
    const targetHeight = 60
    const targetWidth = getTargetWidth(width, height, targetHeight)

    // 인장 dataUrl 을 워크북 이미지로 등록하고, 지정 높이에 맞춘 너비를 계산 (png 가 아니면 정사각형)
    const addStampImage = (dataUrl, height) => {
      const ext = dataUrl.substring(dataUrl.indexOf('/') + 1, dataUrl.indexOf(';')) === 'png' ? 'png' : 'jpeg'
      const imageId = workbook.addImage({
        base64: dataUrl,
        extension: ext,
      })
      const width = ext === 'png' ? getTargetWidth(...getPngSize(dataUrl), height) : height
      return { imageId, width, height }
    }

    // 임대인 인장: 계약 지점에 업로드된 인장 파일 (dataUrl), 템플릿 운영사 인장과 같은 높이
    const stampHeight = 68
    const lessorStamp = addStampImage(repMessage.stamp, stampHeight)
    // 소유주 인장: 전대 지점만 서버가 내려줌 (그 외는 빈 문자열)
    const isSubLease = dataMap.subLeaseYn === 'Y' && !!repMessage.ownerStamp
    const ownerStamp = isSubLease ? addStampImage(repMessage.ownerStamp, stampHeight) : null

    workbook.eachSheet((worksheet, sheetId) => {
      // ExcelJS 는 이미지 삭제 API 가 없어 _media 에서 직접 제외
      worksheet._media = worksheet._media.filter((m) => {
        if (m.type !== 'image') {
          return true
        }
        const col = m.range?.tl?.nativeCol
        const row = m.range?.tl?.nativeRow
        // 템플릿의 운영사 인장 이미지(H66, 0-based col 7 / row 65)는 항상 제거하고 지점 인장으로 대체
        if (col === 7 && row === 65) {
          return false
        }
        // 템플릿의 고정 소유주 인장 이미지(D67, 0-based col 3 / row 66)는 항상 제거하고 지점 소유주 인장으로 대체
        if (col === 3 && row === 66) {
          return false
        }
        return true
      })
      // 전대 지점만 소유주 인장: D69 왼쪽 정렬 '(인)' 글자 위 (0-based col 3 / row 68)
      // A69:C69 문구가 오른쪽 정렬이라 '(인)' 은 항상 문구 바로 뒤, 인장 중심은 D 열 왼쪽에서 약 20px
      if (ownerStamp) {
        worksheet.addImage(ownerStamp.imageId, {
          tl: anchorAt(worksheet, columnToIndex('D'), 20, 68, 1, ownerStamp.width, ownerStamp.height),
          ext: { width: ownerStamp.width, height: ownerStamp.height },
        })
      }
      worksheet.addImage(lessorStamp.imageId, {
        tl: { col: 7.5, row: 65.5 },
        ext: { width: lessorStamp.width, height: lessorStamp.height },
      })
      // 신청자 서명: D65:D67 '(인)' 칸(0-based col 3 / row 64~66) 안에 들어가도록 너비를 칸 폭에 맞추고 가운데 배치
      const sigMaxWidth = colPx(worksheet, columnToIndex('D')) - 10
      const sigWidth = Math.min(targetWidth, sigMaxWidth)
      const sigHeight = sigWidth < targetWidth ? Math.round((sigWidth * height) / width) : targetHeight
      worksheet.addImage(imageId1, {
        tl: centerAnchor(worksheet, columnToIndex('D'), 64, 3, sigWidth, sigHeight),
        ext: { width: sigWidth, height: sigHeight },
      })
      worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
        row.eachCell((cell, colNumber) => {
          if (cell.value && typeof cell.value === 'string') {
            if (cell.value.includes('x_')) {
              const oldValue = cell.value
              const newValue = cell.value.split(' ').reduce((acc, cur) => {
                const key = cur.trim()
                if (key.startsWith('x_')) {
                  let v = dataMap[key]
                  v = key === 'x_amount' || key === 'x_mamount' ? comma(v) : v
                  // 값이 없는 자리표시자는 'undefined' 대신 빈 문자열
                  return acc + ' ' + (v ?? '')
                } else {
                  return acc + ' ' + key
                }
              }, '')
              cell.value = newValue
            }
          }
        })
      })
    })

    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], { type: 'application/octet-stream' })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      // let filename = `${doc.name}_${docName}.xlsx`
      let filename = `${order.companyName}_계약서.xlsx`
      link.download = filename
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    })
  }

  // useAlert 의 alert 는 renderAlert() 를 그려야 화면에 표시됨
  return isAdmin(account) ? (
    <>
      {renderAlert()}
      <Button fullWidth startIcon=<FileDownloadOutlined /> onClick={() => onDownload()}>
        계약서
      </Button>
    </>
  ) : null
}

export default ContractDownloader
